(() => {
  const SELECTOR = '[data-pasquini-banner-video]';

  const isVisible = (video) => {
    const media = video.closest('.pasquini-banner-video__media');
    return !media || window.getComputedStyle(media).display !== 'none';
  };

  const play = (video) => {
    video.muted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    const promise = video.play();
    if (promise && typeof promise.catch === 'function') {
      promise.catch(() => {});
    }
  };

  const setButtonState = (button, isPlaying) => {
    button.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
    button.setAttribute(
      'aria-label',
      isPlaying ? button.dataset.pauseLabel : button.dataset.playLabel
    );
  };

  const init = (root) => {
    if (!root || root.dataset.videoReady === 'true') return;

    const button = root.querySelector('.pasquini-banner-video__toggle');
    const videos = Array.from(root.querySelectorAll('video'));
    if (!button || videos.length === 0) return;

    const syncVisibleVideo = () => {
      const isPlaying = button.getAttribute('aria-pressed') === 'true';

      videos.forEach((video) => {
        if (isVisible(video) && isPlaying) {
          play(video);
        } else {
          video.pause();
        }
      });
    };

    button.addEventListener('click', () => {
      const shouldPlay = button.getAttribute('aria-pressed') !== 'true';
      setButtonState(button, shouldPlay);
      syncVisibleVideo();
    });

    const mediaQuery = window.matchMedia('(max-width: 749px)');
    const handleViewportChange = () => syncVisibleVideo();

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', handleViewportChange);
    } else {
      mediaQuery.addListener(handleViewportChange);
    }

    setButtonState(button, true);
    syncVisibleVideo();

    root._pasquiniBannerVideoCleanup = () => {
      if (typeof mediaQuery.removeEventListener === 'function') {
        mediaQuery.removeEventListener('change', handleViewportChange);
      } else {
        mediaQuery.removeListener(handleViewportChange);
      }
    };
    root.dataset.videoReady = 'true';
  };

  const initAll = (container = document) => {
    container.querySelectorAll(SELECTOR).forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));

  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector?.(SELECTOR);
    if (root?._pasquiniBannerVideoCleanup) {
      root._pasquiniBannerVideoCleanup();
    }
  });
})();
